import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaPiknikFirmowy = () => (
  <SeoPageLayout title="Kabaret na piknik firmowy - śmiech pod chmurką">
    <p>
      Piknik firmowy to jedno z najpopularniejszych wydarzeń integracyjnych. Kabaret na piknik firmowy to atrakcja, która doskonale sprawdza się na świeżym powietrzu - bawi pracowników i ich rodziny, tworząc wyjątkową atmosferę wspólnej zabawy.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Jak wygląda kabaret na pikniku?</h2>
    <p>
      Występ kabaretowy na pikniku firmowym to zazwyczaj 30-60 minut profesjonalnego humoru na scenie plenerowej. Nasi artyści są przyzwyczajeni do występów na zewnątrz i potrafią utrzymać uwagę publiczności nawet w nieformalnej, piknikowej atmosferze.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Co oferujemy na piknik firmowy?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Występ sceniczny - klasyczny kabaret na scenie plenerowej</li>
      <li>Animacje kabaretowe - humor wśród uczestników pikniku</li>
      <li>Prowadzenie pikniku - humorystyczny konferansjer całego dnia</li>
      <li>Konkursy i zabawy - interaktywne elementy z nagrodami</li>
      <li>Program dla rodzin - humor dostosowany do wszystkich grup wiekowych</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Wymagania techniczne</h2>
    <p>
      Na piknik firmowy przyjeżdżamy z własnym sprzętem nagłośnieniowym przystosowanym do warunków plenerowych. Potrzebujemy jedynie dostępu do prądu i zadaszenia sceny w przypadku niepewnej pogody. Resztę zapewniamy sami.
    </p>
  </SeoPageLayout>
);

export default KabaretNaPiknikFirmowy;
